module.exports = require("@mui/icons-material/OpenInFull");